// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { Money2, DocumentUpload, ProfileAdd, Chart2 } from 'iconsax-react';

// icons — one relevant icon per destination
const icons = {
  storeIncentives: Money2,
  dashboard: Chart2,
  targetUpload: DocumentUpload,
  assignedStaffs: ProfileAdd,
};

// ==============================|| MENU ITEMS - STORE INCENTIVES ||============================== //
// Planning-team-only: store-wise target upload and staff lobby assignment.

const storeIncentives = {
  id: 'group-store-incentives',
  title: <FormattedMessage id="Store Incentives" />,
  icon: icons.storeIncentives,
  type: 'group',
  children: [
    {
      id: 'store-incentives-dashboard',
      title: <FormattedMessage id="Dashboard" />,
      type: 'item',
      icon: icons.dashboard,
      url: '/store-incentives/dashboard',
    },
    {
      id: 'store-incentives-target-upload',
      title: <FormattedMessage id="Target Upload" />,
      type: 'item',
      icon: icons.targetUpload,
      url: '/store-incentives/target-upload',
    },
    {
      id: 'store-incentives-assigned-staffs',
      title: <FormattedMessage id="Assigned Staffs" />,
      type: 'item',
      icon: icons.assignedStaffs,
      url: '/store-incentives/assigned-staffs',
    },
  ],
};

export default storeIncentives;
